import { createPageApp } from '@/lib/createPageApp'
import ListProductsPage from './ListProductsPage.vue'

createPageApp(ListProductsPage).mount()
